<template>
  <v-container>
  <div>
    <h1>{{ msg }}</h1>
    <h2>Die aufgerufene Seite wurde nicht gefunden.</h2>
  </div>
  </v-container>
</template>

<script>
export default {
  name: 'PageNotFound',
  data () {
    return {
      msg: ':( '
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PageNotFound.vue